export const isDateISO = (fecha) => {
  if (fecha) {
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(fecha)
  }
}
